module.exports = "/_next/static/images/Andrian_Leca-de7130c784592c01d70714093e5d5a62.webp";